<template lang="pug">
v-navigation-drawer#app-drawer(
  v-model="inputValue",
  app,
  persistent,
  width="275",
  :style="styleDrawer"
)
  f-menu
</template>
<script>
import { mapMutations, mapState } from "vuex";

export default {
  name: "FDrawer",
  props: ["menus", "items"],
  data() {
    return {
      drawer: true,
    };
  },
  computed: {
    ...mapState("app", ["image", "color"]),
    inputValue: {
      get() {
        return this.$store.state.app.drawer;
      },
      set(val) {
        this.setDrawer(val);
      },
    },
    styleDrawer() {
      return window.innerWidth < 800
        ? "background: white"
        : "background:#ffffffa6";
    },
  },
  methods: {
    ...mapMutations("app", ["setDrawer", "toggleDrawer"]),
  },
};
</script>
